module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c(_vm.renderCompanyFlags(), {
    tag: "v-component"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n      ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_vm._v("Дата создания: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.company.createDate)))])]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatStatus(_vm.company.status))
    }
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyOgrn()), 'ОГРН', null, 'Копировать огрн'), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyInn()), 'ИНН', null, 'Копировать инн', _vm.renderInnHtmlBold(_vm.company.inn)), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyKpp()), 'КПП', null, 'Копировать кпп'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_vm._v("Численность: "), _c('b', [_vm._v(_vm._s(_vm.company.staffNumber && _vm.company.staffNumber.value !== null ? _vm.company.staffNumber.value : 'нет данных'))]), _vm._v(" " + _vm._s(_vm.formatDateAt(_vm.company.staffNumber)))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatTaxMode(_vm.company.taxMode))
    }
  }), _vm._v(" "), _c(_vm.createAddressComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.company.heads, _vm.company.management), {
    tag: "component"
  }), _vm._v(" "), (_vm.company.management) ? _c(_vm.createManagementComp(_vm.company.management), {
    tag: "component"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monitoring),
      expression: "monitoring"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("alarm")])], 1), _vm._v(" "), _c('span', [_vm._v("Мониторинг включен")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c(_vm.createCopyButton('Письмо', 'content_copy', 'Копировать для письма', _vm.getEmailHeaderReport), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Преамбула 1', 'content_copy', 'Копировать для преамбулы договора вариант 1', _vm.getAgreementHeader1Report), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Преамбула 2', 'content_copy', 'Копировать для преамбулы договора вариант 2', _vm.getAgreementHeader2Report), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Реквизиты договора', 'content_copy', 'Копировать для реквизитов договора', _vm.getAgreementFooterReport), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Конверт', 'content_copy', 'Копировать для конверта', _vm.getClientEnvelopeReport), {
    tag: "v-component"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f5c6c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/CompanyPanel.vue
// module id = 1022
// module chunks = 1